import { render, staticRenderFns } from "./virtual-keyboard.vue?vue&type=template&id=677aba40&scoped=true"
import script from "./virtual-keyboard.vue?vue&type=script&lang=js"
export * from "./virtual-keyboard.vue?vue&type=script&lang=js"
import style0 from "./virtual-keyboard.vue?vue&type=style&index=0&id=677aba40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677aba40",
  null
  
)

export default component.exports